export default {
  props: ["show"],
  computed: {
    visible() {
      return this.show;
    }
  },
  methods: {
    hideRule() {
      this.$emit('update:show', false);
    }
  }
};